<shared-modal-type-dynamic-height [size]="size" [modalData]="modalData" [center]="true" size="sm"
    (onCloseClick)="handleCloseClick($event)" class="modal-for-loading">

    <div class="modal-for-loading__content">
        <shared-loader-for-spinner [thickness]="5"></shared-loader-for-spinner>
    </div>

</shared-modal-type-dynamic-height>